module.exports = __webpack_public_path__ + "img/3-fr.62bb6c7f.jpg";